import React, { useLayoutEffect, useState, useEffect } from 'react'

import useSignUpAdditionalSteps from 'components/modals/v2/auth/sign_up_additional_details_modal/hooks/use_sign_up_additional_steps'
import useDestroyOngoingStepsData from 'components/modals/v2/auth/sign_up_additional_details_modal/hooks/use_destroy_ongoing_steps_data'
import useBack from 'components/modals/v2/auth/sign_up_additional_details_modal/hooks/use_back'
import useNavigateToLogoStep from './hooks/use_navigate_to_logo_step'
import useSubmitStep from 'components/modals/v2/auth/sign_up_additional_details_modal/hooks/use_submit_step'
import { useModalContext } from 'hooks/use_context'

// https://docs.google.com/spreadsheets/d/17U_U1XJZwtzkQOSv7-xdWPsI2cXf6gruYC6hpzjC9xA/edit#gid=0
const SignUpAdditionalDetails = (props) => {
  const [step, setStep] = useState(0)
  const [serverError, setError] = useState('')
  const [igError, setIgError] = useState('')
  const modalContext = useModalContext()
  const { signUpSteps, currentStep, isLastStep } = useSignUpAdditionalSteps(step)
  const Component = currentStep?.component
  const index = signUpSteps.indexOf(currentStep)
  const progress = parseInt(((index + 1) / signUpSteps.length) * 100)
  const destroyOngoingStepsData = useDestroyOngoingStepsData()
  const onBack = useBack({ setStep, step, index })
  const navigateToLogoStep = useNavigateToLogoStep()

  const onSubmitStep = useSubmitStep({ index, setStep, signUpSteps, isLastStep, navigateToLogoStep, setError })

  useLayoutEffect(() => {
    destroyOngoingStepsData()
  }, [])

  useEffect(() => {
    if (signUpSteps.length === 0) modalContext.onCloseModal() // just in case
  }, [])

  if (!Component) return null

  return (
    <Component
      onBack={onBack}
      serverError={serverError}
      onClose={modalContext.onCloseModal}
      name={currentStep.name}
      index={index}
      progress={progress}
      igError={igError}
      setError={setError}
      setIgError={setIgError}
      onSubmit={onSubmitStep}
      {...props}
    />
  )
}

export default SignUpAdditionalDetails
